import {
    GET_BUSSINESS_DASHBOARD_REQUEST,
    GET_BUSSINESS_DASHBOARD_SUCCESS,
    GET_BUSSINESS_DASHBOARD_ERROR,
  } from "../actions/types";
  
  export const getBussinessDashboardReducer = (state = [], action) => {
    const { type, payload } = action;
    switch (type) {
      case GET_BUSSINESS_DASHBOARD_REQUEST:
        return {
          loading: true,
        };
      case GET_BUSSINESS_DASHBOARD_SUCCESS:
        return {
          ...state,
          loading: false,
          payload,
        };
      case GET_BUSSINESS_DASHBOARD_ERROR:
        return {
          ...state,
          loading: false,
          payload,
        };
  
      default: {
        return state;
      }
    }
  };
  